var map = {
	"./template.betgalaxy": 2062,
	"./template.betgalaxy.tsx": 2062,
	"./template.betprofessor": 1145,
	"./template.betprofessor.tsx": 1145,
	"./template.betroyale": 1146,
	"./template.betroyale.tsx": 1146,
	"./template.default": 661,
	"./template.default.tsx": 661,
	"./template.fiestabet": 1147,
	"./template.fiestabet.tsx": 1147,
	"./template.puntcity": 1148,
	"./template.puntcity.tsx": 1148,
	"./template.puntgenie": 1149,
	"./template.puntgenie.tsx": 1149,
	"./template.questbet": 1150,
	"./template.questbet.tsx": 1150,
	"./template.ts": 973,
	"./template.volcanobet": 1151,
	"./template.volcanobet.tsx": 1151,
	"./template.wellbet": 1152,
	"./template.wellbet.tsx": 1152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2432;